// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxWithLabel_container__1gevz","labelContainer":"CheckboxWithLabel_labelContainer__3Xqlr"};